import { memo } from 'react';

import clsx from 'clsx';
import { UserCircle } from 'lucide-react';
import { isNullish } from 'remeda';

import Avatar from '@mui/material/Avatar';

import css from './UserAvatar.module.css';

import { Nullable, WithClassName } from 'v2/types';

interface UserAvatarProps extends WithClassName {
  imageUrl?: Nullable<string>;
}

export const UserAvatar = memo<UserAvatarProps>(({ className, imageUrl }) => {
  return isNullish(imageUrl) ? (
    <UserCircle className={clsx(css.userAvatarIcon, className)} width={38} height={38} />
  ) : (
    <Avatar className={className} src={imageUrl} />
  );
});

UserAvatar.displayName = 'UserAvatar';
